import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

const INITIAL_STATE_PARAMETERS = {
  'loading': false,
  'list': [],
  'year': '',
  'month': '',
};

export const listCalendar = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_CALENDAR_TEMS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CALENDAR_TEMS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_CALENDAR_TEMS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const listCalendarDetail = (state, action) => {
  return createReducer(INITIAL_STATE_PARAMETERS, {
    [ActionTypes.FETCHING_CALENDAR_DETAIL_TEMS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CALENDAR_DETAIL_TEMS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'year': action.response.year,
      'month': action.response.month,
      'area': action.response.area,
    }),
    [ActionTypes.FETCHED_CALENDAR_DETAIL_TEMS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

